export class Style {
    primaryColor?: string;
    secondaryColor?: string;
}
  